import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Projects/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ProjectQueries extends VueCqrs
{
	runProjectsPageQueryV1(workspaceId: number)
	{
		const query = q.buildProjectsPageQueryV1(workspaceId);
		this.$query(query);
	}

	runProjectTemplateDownloadPageQueryV1(accessKey: string)
	{
		const query = q.buildProjectTemplateDownloadPageQueryV1(accessKey);
		this.$query(query);
	}


	runProjectByIdQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildProjectByIdQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runProjectTemplateLinksQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildProjectTemplateLinksQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runProjectUsersTagsQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildProjectUsersTagsQueryV1(workspaceId, projectId);
		this.$query(query);
	}
}
